<h2>{{ "Select Language" | translate }}</h2>
<form [formGroup]="form" (submit)="handleSubmit()">
  <mat-form-field appearance="outline" color="primary">
    <mat-select formControlName="language">
      <mat-option value="" disabled
        >--{{ "select language" | translate }}--</mat-option
      >
      @for (option of langList; track option) {
        <mat-option [value]="option.code">{{ option.label | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div class="actions">
    <button (click)="bottomSheetRef.dismiss()" type="button" mat-stroked-button>
      {{ "Cancel" | translate }}
    </button>
    <button type="submit" mat-flat-button color="primary">
      {{ "Change" | translate }}
    </button>
  </div>
</form>